const n = (e) => e === "undefined" ? void 0 : JSON.parse(e != null ? e : ""), h = (e) => {
  const c = {};
  return {
    get: (t, r) => {
      var o;
      try {
        return (o = c[t]) != null ? o : n(e.getItem(t));
      } catch {
        return r;
      }
    },
    set: (t, r) => {
      try {
        e.setItem(t, JSON.stringify(r)), delete c[t];
      } catch {
        c[t] = r;
      }
    },
    remove: (t) => {
      try {
        e.removeItem(t);
      } catch {
        delete c[t];
      }
    },
    clear: () => {
      try {
        e.clear();
      } catch {
        Object.keys(c).forEach((t) => delete c[t]);
      }
    }
  };
};
export {
  h as localStorageApiFactory
};
